var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('KeywordPlannerAddKeywordForm',{attrs:{"show":_vm.show && !_vm.errors.length},on:{"error":_vm.handleError,"back":_vm.back,"hide":_vm.close}}),_vm._v(" "),_c('KeywordPlannerAddKeywordError',{attrs:{"show":_vm.show && Boolean(_vm.errors.length),"errors":_vm.errors},on:{"hide":_vm.resetErrorsAndClose}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }